<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/estate/banner.png" @click="$login">
    <text-left
      :text-left="{
        height: 430,
        title: '集中管理公司固定资产',
        desc: '轻松维护您所有的业务资产，包括资产，车辆，设备，机械，硬件和其他。在账套中手工创建单个资产，或者使用xml快速批量导入所有资产信息。',
        textWidth: 800,
        imgWidth: 290,
        left: false,
        img: require('@/assets/estate/img1.png')
      }"/>
    <text-left
      :text-left="{
        height: 440,
        title: '计算折旧',
        desc: '设置适用于您的业务和资产类型的资产类别。指定购买日期，购买价格，有效期限，残值率，折旧方法，以便准确的计算固定资产的折旧费用和现有价值。',
        textWidth: 670,
        imgWidth: 320,
        left: true,
        img: require('@/assets/estate/img2.png')
      }"/>
    <text-left
      :text-left="{
        height: 470,
        title: '全面了解您的固定资产',
        desc: '通过折旧汇总表快速查看指定期间的固定资产折旧情况，包括资产状态，剩余价值，剩余使用期限。',
        textWidth: 700,
        imgWidth: 340,
        left: false,
        img: require('@/assets/estate/img3.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'

export default {
  name: 'Estate',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/fapiao.png'),
          title: '发票管理',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/bill'
        },
        {
          img: require('@/assets/common/xiaoshou.png'),
          title: '销售账单管控',
          desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
          path: '/sale'
        },
        {
          img: require('@/assets/common/caigou.png'),
          title: '采购账单管控',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/purchase'
        },
        {
          img: require('@/assets/common/feiyong.png'),
          title: '费用报销管理',
          desc: '员工随时随地登录系统，完成费用报销申请与审批',
          path: '/reimbursement'
        },
        {
          img: require('@/assets/common/guding.png'),
          title: '固定资产',
          desc: '集中管理，轻松维护您的固定资产',
          path: '/estate'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
